import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-widget-number-of-records-to-take',
    templateUrl: './number-of-records-to-take.component.html',
    styleUrls: ['./number-of-records-to-take.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class WidgetNumberOfRecordsToTakeComponent {
    @Input() value;
    @Output() valueChange = new EventEmitter();

    options = [1, 2, 3, 4, 5, 10, 20, 50, 100];

    onValueChange($event) {
        this.valueChange.emit($event);
    }
}
